import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { BankTransaction } from '../models/bank-transaction';

@Injectable({
  providedIn: 'root'
})
export class BankTransactionService {
  private cache: BankTransaction[] = [];

  constructor(private http: HttpClient) {}

  getAll(): Observable<BankTransaction[]> {
    if (this.cache.length > 0) {
      return of(this.cache);
    }

    const url = `${environment.apiUrl}banktransactions`;
    return this.http.get<BankTransaction[]>(url).pipe(
      tap(items => this.cache = items)
    );
  }

  /**
   * Patch a single field on a bank transaction using field-level updates.
   * Only allows patching: category, subcategory, campaign_id, reimbursable.
   * Sends PATCH to banktransactions/{id}/field with body { field, value }.
   */
  patchTransaction(id: string, field: 'category' | 'subcategory' | 'campaign_id' | 'reimbursable', value: any): Observable<void> {
    // Validate allowed fields
    const allowedFields = ['category', 'subcategory', 'campaign_id', 'reimbursable'];
    if (!allowedFields.includes(field)) {
      throw new Error(`Field '${field}' is not allowed for patching. Allowed fields: ${allowedFields.join(', ')}`);
    }

    const url = `${environment.apiUrl}banktransactions/${id}/field`;
    const body = { field, value };

    return this.http.patch<void>(url, body).pipe(
      tap(() => {
        // Update the local cache with the new value on successful response
        const idx = this.cache.findIndex(t => t.id === id);
        if (idx >= 0) {
          (this.cache[idx] as any)[field] = value;

          // Special handling for category changes - clear subcategory
          if (field === 'category') {
            this.cache[idx].subcategory = '';
          }
        }
      })
    );
  }
}
